import { render, staticRenderFns } from "./TheSidebarOld.vue?vue&type=template&id=7793749f"
import script from "./TheSidebarOld.vue?vue&type=script&lang=js"
export * from "./TheSidebarOld.vue?vue&type=script&lang=js"
import style0 from "./TheSidebarOld.vue?vue&type=style&index=0&id=7793749f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports